
export const SortArrowDown = () =>{
    return     <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.66667 1.3335V10.6668M5.66667 10.6668L10.3333 6.00016M5.66667 10.6668L1 6.00016"
      stroke="#667085"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
}